import { Component, Input } from '@angular/core';
import {ThingAlarmsInterface} from '@app/app/shared/interfaces/thing/thing-alarms.interface';

@Component({
  templateUrl: './park-alarms-item.html',
  selector: 'park-alarms-item'
})
export class ParkAlarmsItemComponent {
  @Input() alarm: ThingAlarmsInterface;
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/alarms/message/park-alarms-item.component.ts